import { keys } from "../../common/util/ObjectEntries";
import { CHILD_TYPES, TAnyNodeID } from "../_generated/NodeTypes";
import { useSharedState, useSharedStateReadOnly } from "../app/useSharedState";
import { useSceneAction } from "../hooks/useSceneAction";
import { newIds } from "../Scene";
import { positionAtEnd, positionWithWriterId } from "../util/FracList";
import "./ContextMenu.css";
import { ContextMenuBase } from "./ContextMenuBase";

type TProps = {};

export function ContextMenu({}: TProps) {
  const [activeContextMenu] = useSharedStateReadOnly("activeContextMenu");
  const [scene, setScene] = useSharedState("scene");
  const [ws] = useSharedState("serverSocket");
  const [roomMemberId] = useSharedState("roomMemberId");

  const updateScene = useSceneAction();

  if (activeContextMenu === null) {
    return null;
  }

  let items = [];

  if (activeContextMenu.type === "control") {
    const node = scene.nodes[activeContextMenu.controlId as TAnyNodeID];

    // const deleter = spec.canDelete(scene, control.id);
    // if (deleter !== undefined) {
    //   items = [
    //     {
    //       label: "Delete",
    //       action: () => {
    //         updScene((scene) => deleter(scene));
    //       },
    //     },
    //   ];
    // }

    if (node.parent !== undefined) {
      const parentNode = scene.nodes[node.parent.id];
      // if (CHILD_TYPES[parentNode.type][key] === "line_list") {
      //   items.push({
      //     label: "Remove",
      //     action: () => {
      //       updScene((scene) => removeControl(scene, control.id));
      //     },
      //   });
      // }
    }

    if ("children" in node) {
      for (const key of keys(node.children)) {
        console.log(key, CHILD_TYPES[node.type][key]);
        switch (CHILD_TYPES[node.type][key]) {
          case "list":
            for (const option of CHILD_TYPES[node.type][key].nodeTypes) {
              items.push({
                label: option,
                action: () => {
                  // setScene(
                  //   updateSceneAndCommit(scene, ws, {
                  updateScene({
                    action: "add_list_child",
                    id: activeContextMenu.controlId,
                    childKey: key,
                    position: positionWithWriterId(
                      positionAtEnd(node.children[key]),
                      roomMemberId
                    ),
                    childType: option,
                    newIds: newIds(option),
                  });
                  //   })
                  // );
                },
              });
            }
            break;
          case "set":
            items.push({
              label: `Add ${key}`,
              children: ["surface"].map((v) => ({
                label: v,
                action: () => {
                  // setScene(
                  //   updateSceneAndCommit(scene, ws, {
                  updateScene({
                    action: "add_grid_set_child",
                    id: activeContextMenu.controlId,
                    childKey: key,
                    position: activeContextMenu.position,
                    childType: v,
                    newIds: newIds(v),
                  });
                  //   })
                  // );
                },
              })),
            });
            break;
        }
      }
    }
  }

  const position = activeContextMenu.position;

  return (
    <ContextMenuBase
      key={position.join()}
      items={items}
      anchorRight={position[0]}
      anchorTop={position[1]}
    />
  );
}
